export default __webpack_public_path__ + "static/media/MotorInsurance.be2e8257.svg";